import { formatNumberWithOrdinal } from "capitalrx-utilities";

const getUsersTimezone = () => {
  return new Intl.DateTimeFormat().resolvedOptions().timeZone;
};

const getPaymentDayOptionsArray = (translate: CallableFunction, current_language: string) => {
  const paymentDayOptionsArray: Array<{ key: number, label: string }> = [];

  for (let i = 5; i <= 28; i++) {
    paymentDayOptionsArray.push({
      key: i,
      label: translate(current_language === "en" ? formatNumberWithOrdinal(i) : i.toString()),
    });
  }

  return paymentDayOptionsArray;
};

export { getUsersTimezone, getPaymentDayOptionsArray };
